import { getDateFnsLocaleModule } from '@vmos2/core';
import { useEffect, useState } from 'react';

import { useIsMounted } from '../useIsMounted';

export const useDateFnsLocale = (language: string) => {
  const [dateFnsLocale, setDateFnsLocale] = useState<Locale | null>(null);
  const isMounted = useIsMounted();

  useEffect(() => {
    getDateFnsLocaleModule(language).then(module => {
      if (isMounted.current) {
        setDateFnsLocale(module.default);
      }
    });
  }, [isMounted, language]);

  return dateFnsLocale;
};
